const SaveButton = ({clickHandler}) => {

    return (
        <button
            type="button"
            className="save-btn"
            onClick={clickHandler}
        >
            Save Changes
        </button>
    )
}

export default SaveButton